import { useState } from "react";
import "./style.css";
import axios from "axios";
import env from "../../../../config/env"
import { useUserInfo } from "../../../../context/user";
import EditIcon from "@mui/icons-material/Edit";
import EditFieldModal from "./components/EditFieldModal";
import ChangePasswordDialog from "./components/ChangePasswordDialog";
import toast from "react-hot-toast";
import Icon from "../../../../components/icons";


function ProfileContent() {
  const BASE_URL = `${env.API_URL}/v1`;
  const user = useUserInfo()[0];
  const updateUser = useUserInfo()[1];
  const userActiveLocation = useUserInfo()[4];
  const [formData, setFormData] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [activeField, setActiveField] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleEditClick = (field) => {
    setActiveField(field);
    setModalOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(`${BASE_URL}/user/chatuser/update`, {
        _id: user._id,
        userName: e.target.userName.value,
        email: e.target.email.value,
        contactNumber: e.target.contactNumber.value,
      });

      if (response) {
        updateUser(response?.data);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while updating user");
      toast.error("Please try again later");
    }
  };

  const handlePasswordChange = async (passwordData) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/user/chatuser/update/password`,
        {
          _id: user._id,
          old_password: passwordData.currentPassword,
          new_password: passwordData.newPassword,
          c_new_password: passwordData.newPassword,
        }
      );
      if (response && response.data) {
        toast.success("Password updated successfully");
        updateUser(response.data);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while updating user");
      toast.error("Please try again later");
    }
  };

  return (
    <div className="">
      <form className="" onSubmit={(e) => handleSubmit(e)}>
        <h2
          style={{ marginBottom: "20px", fontSize: "20px", fontWeight: "bold" }}
        >
          Profile
        </h2>
        <div className="">
          <div className="form-group flex gap-12">
            <div className="w-[40%]">
              <label htmlFor="userName" className="text-[#757575]">
                User Name
              </label>
              <div className="relative">
                <input
                  type="text"
                  className="form-control mt-2"
                  id="userName"
                  name="userName"
                  value={user?.userName || ""}
                  onChange={(e) => handleChange(e)}
                />

                <div
                  onClick={() => handleEditClick("userName")}
                  className="p-3 absolute top-1 right-1 text-[#757575] cursor-pointer"
                >
                  <EditIcon fontSize="16" className="" />
                </div>
              </div>
            </div>
            <div className="w-[40%]">
              <label htmlFor="business_name" className="text-[#757575]">
                Business Name
              </label>
              <div className="relative">
                <input
                  type="text"
                  className="form-control mt-2"
                  id="business_name"
                  name="business_name"
                  value={userActiveLocation?.business_name || ""}
                  onChange={(e) => handleChange(e)}
                />

                <div
                  onClick={() => handleEditClick("business_name")}
                  className="p-3 absolute top-1 right-1 text-[#757575] cursor-pointer"
                >
                  <EditIcon fontSize="16" className="" />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mt-4 flex gap-12">
            <div className="w-[40%]">
              <label htmlFor="email" className="text-[#757575]">
                Email
              </label>
              <div className="relative">
                <input
                  type="email"
                  className="form-control mt-2"
                  id="email"
                  name="email"
                  value={user?.email || ""}
                  onChange={(e) => handleChange(e)}
                />

                <div
                  onClick={() => handleEditClick("email")}
                  className="p-3 absolute top-1 right-1 text-[#757575] cursor-pointer"
                >
                  <EditIcon fontSize="16" className="" />
                </div>
              </div>
            </div>
            <div className="w-[40%]">
              <label htmlFor="password" className="text-[#757575]">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control mt-2"
                  id="password"
                  name="password"
                  value={user?.assign_password || ""}
                  disabled
                />

                <div
                  onClick={togglePassword}
                  className="p-3 absolute top-1 right-1 text-[#757575] cursor-pointer"
                >
                  <Icon id={showPassword ? "eyeCrossIcon" : "eyeIcon"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <button
        className="mt-4 font-medium w-[calc(48px+79%)] text-end"
        onClick={() => setOpen(true)}
      >
        Change Password
      </button>

      <EditFieldModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        field={activeField}
        label={
          activeField === "userName"
            ? "Username"
            : activeField === "business_name"
              ? "Business Name"
              : "Email"
        }
        user={user}
        updateUser={updateUser}
        userActiveLocation={userActiveLocation}
      />

      <ChangePasswordDialog
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handlePasswordChange}
      />
    </div>
  );
}
export default ProfileContent;
